if (!customElements.get('vtv-3d-stage')) {
  customElements.define('vtv-3d-stage', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.viewer = this.querySelector('model-viewer');
      this.status = this.querySelector('[role="status"]');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.viewer.addEventListener('load', () => {
        this.classList.add('is-ready');
        this.status.hidden = true;
      }, options);
      this.viewer.addEventListener('error', () => this.showError(), options);
      this.motion.addEventListener('change', () => this.updateRotation(), options);
      document.addEventListener('visibilitychange', () => this.updateRotation(), options);
      this.preload = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        this.preload.disconnect();
        if (!this.viewer.dataset.src) { this.showError('Add a GLB file link in the section settings.'); return; }
        this.viewer.setAttribute('src', this.viewer.dataset.src);
      }, { rootMargin: '400px' });
      this.preload.observe(this);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        if (this.visible) this.classList.add('is-revealed');
        this.updateRotation();
      }, { threshold: .15 });
      this.observer.observe(this);
      this.updateRotation();
    }
    updateRotation() {
      this.viewer.toggleAttribute('auto-rotate', this.dataset.autoRotate === 'true' && !this.motion.matches && this.visible && !document.hidden);
    }
    showError(message) {
      this.status.hidden = false;
      this.status.textContent = message || 'The 3D view could not load. Please reload the page.';
    }
    disconnectedCallback() {
      this.abort.abort();
      this.preload.disconnect();
      this.observer.disconnect();
      this.viewer.removeAttribute('auto-rotate');
    }
  });
}
